import { createApp } from 'vue';
import { createPiniaInstance, i18n, registerPlugins } from '@/config';
import App from './App.vue';
import { createRouterInstance } from '@/config';

// Style imports
import '@unocss/reset/tailwind.css';
import 'uno.css';
import 'virtual:uno.css';
import 'prismjs';

const initializeApp = () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  const app = createApp(App);
  const router = createRouterInstance();
  // Core configurations
  app.use(createPiniaInstance());
  app.use(i18n);
  app.use(router);

  // Plugin/component registration
  registerPlugins(app);

  return app;
};

const mountApp = () => {
  const app = initializeApp();
  app.mount('#app');
};

mountApp();
